<div class="tab-pane" role="tabpanel" id="antecedentes">
    <fieldset id="agregar_antecedentes" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content" *ngIf="acotado">
                    <h3 class="form-signin-heading"><strong>Antecedentes </strong></h3>
                    <hr />
                    <div class="form-horizontal">
                        <div class="form-group" style="padding-top: 20px;">
                            <div class="col-md-2"></div>
                            <div class="col-md-5" align="right">
                                <button mat-raised-button color="primary" style="padding-top: 5px"
                                    id="ingreso_antecedentes" (click)="add_docs()">
                                    Agregar Documento
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>Nombre</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.nombre}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>

                                    <span (click)="delete_docs(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>


                <div class="col-md-12" id="content" *ngIf="!acotado">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Antecedentes de Permisos y Recepciones
                                Anteriores</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group">

                                <label for="permiso" class="col-md-2" style=" padding-top: 15px;" align="left">Tipo de
                                    Permisos</label>
                                <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <mat-select [(value)]="selected" formControlName="tipo_permiso"
                                            id="tipo_permiso" name="tipo_permiso"
                                            placeholder="Seleccione Tipo de Permiso">
                                            <mat-option value="Permiso Primitivo">Permiso Primitivo</mat-option>
                                            <mat-option value="Modificaciones y Ampliaciones">Modificaciones y
                                                Ampliaciones</mat-option>
                                            <mat-option value="Recepcion">Recepcion</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="permiso" class="col-md-2" style=" padding-top: 15px;"
                                    align="left">Permiso</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Permiso" id="permiso" name="permiso"
                                            formControlName="permiso">
                                        <mat-error *ngIf="form.controls?.permiso.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="nro_permiso" class="col-md-2"
                                    style=" padding-top: 15px;">N&uacute;mero</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Número" id="nro_permiso" name="nro_permiso" formControlName="numero" inputmode=”numeric” pattern="[0-9]*" >
                                        
                                        <mat-error *ngIf="form.controls['numero'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  

                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="fecha_permiso" class="col-md-2" style=" padding-top: 15px;"
                                    align="left">Fecha</label>
                                <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" id="fecha" name="fecha" formControlName="fecha">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>

                                </div>

                            </div>
                            <div class="form-group">
                                <label for="sup_permiso" class="col-md-2" style=" padding-top: 15px;"
                                    align="left">Superficie M2</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie" id="superficie" name="superficie" formControlName="superficie" inputmode=”numeric” pattern="[0-9]*" >
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['superficie'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" style="padding-top: 20px;">
                                <div class="col-md-2"></div>
                                <div class="col-md-5" align="right">
                                    <button mat-raised-button color="primary" style="padding-top: 5px"
                                        id="ingreso_antecedentes" (click)="add_antecedentes()">
                                        Agregar Antecedentes
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>



                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>TIPO PERMISO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.tipo_permiso}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PERMISO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.permiso}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PERMISO NRO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.numero}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>FECHA PERMISO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.fecha}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERFICIE M2</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superficie}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_antecedentes(rowIndex)" style="padding-right: 5px;"><i
                                            class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_antecedentes(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <!--Material Modal Dialog-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de los Antecedentes</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion solicitada</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="tipo">Tipo de Solicitud</label>
                    <div class="col-md-6">
                        <input id="numpermiso" name="numpermiso" type="hidden" placeholder="numpermiso"
                            class="form-control input-md" [(ngModel)]="temp_ant.numpermiso">
                        <select type="select" class="form-control" id="tipo_permiso" name="tipo_permiso"
                            [(ngModel)]="temp_ant.tipo_permiso" (change)="onChangeSelect($event)"
                            placeholder="Tipo de Permiso">
                            <option value="default">Seleccione Tipo de Permiso</option>
                            <option value="Permiso Primitivo">Permiso Primitivo</option>
                            <option value="Modificaciones y Ampliaciones">Modificaciones y Ampliaciones</option>
                            <option value="Recepcion">Recepcion</option>
                        </select>
                        <!-- <input id="sup_permiso" name="sup_permiso" type="text" placeholder="sup_permiso" class="form-control input-md" [(ngModel)]="antecedente.tipo"> -->
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="permiso">Permiso</label>
                    <div class="col-md-6">
                        <input id="permiso" name="permiso" type="text" placeholder="permiso"
                            class="form-control input-md" [(ngModel)]="temp_ant.permiso">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="numero">Permiso Numero</label>
                    <div class="col-md-6">
                        <input id="numero" name="numero" type="text" placeholder="numero" class="form-control input-md" [(ngModel)]="temp_ant.numero"> <!--para que aparezca error hay que agregarle form pero eso no permite ngModel-->
                        <mat-error *ngIf="form.controls['numero'].hasError('pattern')">
                            Solo se permiten caracteres <strong>numéricos</strong>
                        </mat-error>  
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fecha">Fecha</label>
                    <div class="col-md-6">
                        <input id="fecha" name="fecha" type="text" placeholder="fecha" class="form-control input-md"
                            value="{{temp_ant.fecha}}">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="superficie">Superficie</label>
                    <div class="col-md-6">
                        <input id="superficie" name="superficie" type="text" placeholder="superficie"
                            class="form-control input-md" [(ngModel)]="temp_ant.superficie">
                    </div>
                    <div class="col-md-2"></div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_antecedente" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_antecedente" (click)="saveAntecedentes() ">Ingresar
                Antecedentes <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<!--Material Dialog Modal No existe ROL-->
<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
        No ingreso ningun dato al antecedente.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<div class="separator"></div>

<!--Material Dialog Modal se ingresa listado de docs-->
<ng-template #openModalNODOC>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-form-field class="col-md-12">
        <mat-label>Nombre del Documento</mat-label>
        <input type="text" matInput [(ngModel)]="documentoNombre" required>
    </mat-form-field>


    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="add()" [disabled]="!documentoNombre">Agregar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #openModalNOVALID>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       Ingreso datos incorrectos al antecedente.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<div class="separator"></div>